module.exports = __webpack_public_path__ + "img/PL.ea1bc2cd.svg";